import { render, staticRenderFns } from "./Channels.vue?vue&type=template&id=6be794e7&scoped=true"
import script from "./Channels.vue?vue&type=script&lang=js"
export * from "./Channels.vue?vue&type=script&lang=js"
import style0 from "./Channels.vue?vue&type=style&index=0&id=6be794e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be794e7",
  null
  
)

export default component.exports